import isURL from "validator/lib/isURL";
import isEmail from 'validator/es/lib/isEmail';
import dayjs from "dayjs";
import { Field } from "./Field";
import { IFieldValidationResult } from "../../interfaces";
import { DataTypes } from "../../../../metadata/Datatypes";
import { Localization } from "../../../../../localization";

export class FieldValidation {
    private _field: Field;
    constructor(field: Field) {
        this._field = field;
    }

    public isValid(): IFieldValidationResult {
        const result = this._getValidationResult();
        return result;
    }

    private _getValidationResult(): IFieldValidationResult {
        const validationExpression = this._field.getValidationExpression();
        //run custom validator before native one
        if (validationExpression) {
            const validationResult = validationExpression();
            if (validationResult.error) {
                return validationResult;
            }
        }
        const column = this._field.getColumn();
        const value = this._field.getValue();
        const isRequired = this._field.getRequiredLevel() === 'required';
        if (isRequired && this._isNull(value)) {
            return {
                error: true,
                errorMessage: Localization.GetString('utils/dataset/data-providers/Record/Field/Validation/ColumnRequired')
            };
        }
        //value is not required and is null => validation success
        if (this._isNull(value)) {
            return {
                error: false,
                errorMessage: ''
            };
        }
        //TODO: validation per datatype metadata
        switch (column?.dataType) {
            case DataTypes.WholeNone:
            case DataTypes.Decimal:
            case DataTypes.Currency:
            case DataTypes.WholeDuration: {
                if (typeof value === 'string') {
                    return {
                        error: true,
                        errorMessage: Localization.GetString("utils/dataset/data-providers/Record/Field/Validation/InvalidNumber")
                    };
                }
                break;
            }
            case DataTypes.SingleLineEmail: {
                if (!isEmail(`${value}`)) {
                    return {
                        error: true,
                        errorMessage: Localization.GetString("utils/dataset/data-providers/Record/Field/Validation/InvalidEmail")
                    };
                }
                break;
            }
            case DataTypes.SingleLineUrl: {
                if (!isURL(`${value}`)) {
                    return {
                        error: true,
                        errorMessage: Localization.GetString("utils/dataset/data-providers/Record/Field/Validation/InvalidUrl")
                    };
                }
                break;
            }
            case DataTypes.DateAndTimeDateAndTime:
            case DataTypes.DateAndTimeDateOnly: {
                const date = dayjs(value);
                if (!date.isValid()) {
                    return {
                        error: true,
                        errorMessage: Localization.GetString("utils/dataset/data-providers/Record/Field/Validation/InvalidDate")
                    };
                }
            }
        }

        return {
            error: false,
            errorMessage: ''
        };
    }

    private _isNull(value: any): boolean {
        switch (value) {
            case undefined:
            case null:
            case "": {
                return true;
            }
        }
        return false;
    }
}